import React from "react"
import { Box, Image } from "rebass"
import styled from 'styled-components'

const CustomImage = styled(Image)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.5rem;
  margin-top: .5rem;
`

const ImageParser = ( props ) => (
  <Box>
    <CustomImage src={props.src} />
  </Box>
)

export default ImageParser;


// WEBPACK FOOTER //
// ./src/components/markdown/ImageParser.js